import React from 'react';
import { tutorials } from './tutorials_data';
import TutorialCard from './TutorialCard';

function TutorialsDevsContainer() {
  return (
    <div
      className={
        'md:p-5 flex flex-col scrollbar-hide max-h-[calc(100vh_-_166px)] min-h-[calc(100vh_-_166px)] md:max-h-[calc(100vh_-_136px)] md:min-h-[calc(100vh_-_136px)] w-full overflow-y-scroll'
      }
    >
      <div
        className={
          'grid grid-cols-3 gap-4 auto-rows-max auto-cols-max grid-flow-row-dense'
        }
      >
        {tutorials.map((tutorial) => {
          return (
            <div key={tutorial.index}>
              <TutorialCard tutorial={tutorial} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TutorialsDevsContainer;
